
import { useTranslation } from "react-i18next";
import NavigationMenu from "@/components/layout/NavigationMenu";
import { BallDistanceTracker } from "@/components/golf/BallDistanceTracker";

const BallDistance = () => {
  const { t } = useTranslation('common');
  
  return (
    <div className="min-h-screen bg-gradient-to-b from-golf-50 to-white">
      <NavigationMenu />
      
      <div className="container mx-auto p-8 pb-16">
        <h1 className="text-2xl font-bold mb-6">{t('ballDistance.title')}</h1>
        <BallDistanceTracker />
      </div>
    </div>
  );
};

export default BallDistance;
